import React from "react"
import balanceTransferImage from "../../media/images/icon-balance-transfer.svg";


import ShieldLockWithPapers from "../../media/images/cc_eligibilty_step2.webp";
import Cards from "../../media/images/cc_eligibilty_step1-v2.webp"
import Accepted80 from "../../media/images/img-20.webp"

const CreditCardsArticle = () => {
  return (
    <article className="column eligibility-article--credit-cards">
      <h2 className="line-heading main-heading blue hide-mobile">
        <span className="large-heading-text">
          Credit Card
          <br />
          Eligibility Calculator
        </span>
      </h2>
      <div className="row">
        <div className="col-12 col-sm-3">
          <p>
            A few years ago, the only way to know if you'd be accepted for a
            credit card was to apply, but that leaves a mark on your credit
            report that lenders could see, impacting your ability to get credit
            in future. Our Eligibility Calculator uses a 'soft search' (that
            lenders can't use) to calculate and show your percentage chance of
            getting top credit cards.
          </p>
        </div>
        <div className="col-12 col-sm-9">
          <ol className="step-list with-margin-top">
            <li>
              <div className="step-head">
                <strong className="in">
                  <span className="num">1.</span> Choose the right type of card
                  for you
                </strong>
              </div>
              <img width={120} height={120} src={Cards} alt="Cards" />
              <div className="descr">
                <p>
                  Don't know what you're looking for? We describe below what the
                  cards do to help you choose
                </p>
              </div>
            </li>
            <li>
              <div className="step-head">
                <strong className="in">
                  <span className="num">2.</span> Fill in our form, and we check
                  your chances
                </strong>
              </div>
              <img
                width={120}
                height={120}
                src={ShieldLockWithPapers}
                alt="Shield lock with papers"
              />
              <div className="descr">
                <p>
                  It should only take a few minutes, and our search won't impact
                  your credit score
                </p>
              </div>
            </li>
            <li>
              <div className="step-head">
                <strong className="in">
                  <span className="num">3.</span> See which cards you have the
                  best chance of getting
                </strong>
              </div>
              <img
                width={120}
                height={120}
                src={Accepted80}
                alt="80% accepted"
              />
              <div className="descr">
                <p>
                  Compare your scores and the cards' features, then choose and
                  apply
                </p>
              </div>
            </li>
          </ol>
          <p className="new-info">
            <strong>
              <span className="text-highlight">New.</span> Some cards now give
              100% acceptance chance - meaning you're pre-approved to get them.
            </strong>
          </p>
        </div>
      </div>

      <h2 className="large-heading line-heading">
        <span className="large-heading-text">Get started</span>
      </h2>
      <div className="row">
        <div className="col-12 col-sm-3 hide-mobile-and-tablet">&nbsp;</div>
        <div className="col-12 col-sm-9 card-types-container">
          <ul className="card-types">
            <li className="balance-transfer">
              <div className="icon-column">
                <a
                  href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_BALTRANSFERV2"
                  className="card-type-icon"
                  id="balance-transfer-icon-link"
                >
                  <img
                    width={57}
                    height={57}
                    className="icon-placeholder"
                    aria-hidden
                    src={balanceTransferImage}
                    alt="balance-transfer-icon-link"
                    loading="lazy"
                  />
                </a>
              </div>
              <div className="text-column">
                <div className="card-type-text">
                  <h3>
                    <a
                      href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_BALTRANSFERV2"
                      id="balance-transfer-title-link"
                    >
                      <strong>Balance Transfers</strong>{" "}
                      <span className="hide-mobile">-</span> Cut existing debt
                      costs
                    </a>
                  </h3>
                  <p>
                    A balance transfer's when you use one card to pay off other
                    credit or store cards, so you owe the new one but at a far
                    lower rate - often 0% - making you debt-free quicker, as
                    repayments cover debt, not interest.
                  </p>
                </div>
                <div className="card-type-button">
                  <a
                    href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_BALTRANSFERV2"
                    className="card-type-cta"
                    id="balance-transfer-cta-link"
                  >
                    Check my chances
                  </a>
                  <p>
                    Full info:
                    <br />
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.moneysavingexpert.com/credit-cards/balance-transfer-credit-cards"
                      id="balance-transfer-full-info-link"
                    >
                      Balance Transfer Credit Cards
                    </a>
                  </p>
                </div>
              </div>
            </li>
            <li className="bad-credit">
              <div className="icon-column">
                <a
                  href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_CREDITBUILDER"
                  className="card-type-icon"
                  id="bad-credit-icon-link"
                >
                  <img
                    width={57}
                    height={57}
                    className="icon-placeholder"
                    aria-hidden
                    src={balanceTransferImage}
                    alt="balance-transfer-icon-link"
                    loading="lazy"
                  />
                </a>
              </div>
              <div className="text-column">
                <div className="card-type-text">
                  <h3>
                    <a
                      href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_CREDITBUILDER"
                      id="bad-credit-title-link"
                    >
                      <strong>'Bad Credit'</strong>
                      <span className="hide-mobile">-</span> For poorer credit
                      scorers or to (re)build your credit
                    </a>
                  </h3>
                  <p>
                    if you've no credit history, or a history of missed payments
                    or defaults, you're likely to be rejected when applying for
                    credit. But easier-to-get 'bad credit' cards can help you
                    rebuild your credit score.
                  </p>
                </div>
                <div className="card-type-button">
                  <a
                    href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_CREDITBUILDER"
                    className="card-type-cta"
                    id="bad-credit-cta-link"
                  >
                    Check my chances
                  </a>
                  <p>
                    Full info: <br />
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.moneysavingexpert.com/credit-cards/bad-credit-credit-cards"
                      id="bad-credit-full-info-link"
                    >
                      Credit Cards for Bad Credit
                    </a>
                  </p>
                </div>
              </div>
            </li>
            <li className="purchases">
              <div className="icon-column">
                <a
                  href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_PURCHASE"
                  className="card-type-icon"
                  id="purchases-icon-link"
                >
                  <img
                    width={57}
                    height={57}
                    className="icon-placeholder"
                    aria-hidden
                    src={balanceTransferImage}
                    alt="balance-transfer-icon-link"
                    loading="lazy"
                  />
                </a>
              </div>
              <div className="text-column">
                <div className="card-type-text">
                  <h3>
                    <a
                      href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_PURCHASE"
                      id="purchases-title-link"
                    >
                      <strong>0% Spending</strong>
                      <span className="hide-mobile">-</span> Interest free (&
                      low interest) cards
                    </a>
                  </h3>
                  <p>
                    If you've a big, planned, budgeted-for purchase, a 0% credit
                    card is THE cheapest way to borrow as it lets you spread the
                    cost over two years or more completely interest free.
                  </p>
                </div>
                <div className="card-type-button">
                  <a
                    href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_PURCHASE"
                    className="card-type-cta"
                    id="purchases-cta-link"
                  >
                    Check my chances
                  </a>
                  <p>
                    Full info: <br />
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.moneysavingexpert.com/credit-cards/best-0-credit-cards"
                      id="purchases-full-info-link"
                    >
                      0% Spending Credit Cards
                    </a>
                  </p>
                </div>
              </div>
            </li>
            <li className="all-rounder">
              <div className="icon-column">
                <a
                  href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_BALTRANSFERPURCHASE"
                  className="card-type-icon"
                  id="all-rounder-icon-link"
                >
                  <img
                    width={57}
                    height={57}
                    className="icon-placeholder"
                    aria-hidden
                    src={balanceTransferImage}
                    alt="balance-transfer-icon-link"
                    loading="lazy"
                  />
                </a>
              </div>
              <div className="text-column">
                <div className="card-type-text">
                  <h3>
                    <a
                      href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_BALTRANSFERPURCHASE"
                      id="all-rounder-title-link"
                    >
                      <strong>All-rounder</strong>
                      <span className="hide-mobile">-</span> Balance transfers
                      &amp; spending
                    </a>
                  </h3>
                  <p>
                    Credit cards tend to be either good balance transfer deals,
                    or an offer of low rates on new spending, but these cards
                    offer cheap intro rates on BOTH balance transfers AND new
                    spending.
                  </p>
                </div>
                <div className="card-type-button">
                  <a
                    href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_BALTRANSFERPURCHASE"
                    className="card-type-cta"
                    id="all-rounder-cta-link"
                  >
                    Check my chances
                  </a>
                  <p>
                    Full info: <br />
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.moneysavingexpert.com/credit-cards/0-balance-transfers-spending"
                      id="all-rounder-full-info-link"
                    >
                      All-rounder Credit Cards
                    </a>
                  </p>
                </div>
              </div>
            </li>
            <li className="money-transfers">
              <div className="icon-column">
                <a
                  href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_MONEYTRANSFER"
                  className="card-type-icon"
                  id="money-transfers-icon-link"
                >
                  <img
                    width={57}
                    height={57}
                    className="icon-placeholder"
                    aria-hidden
                    src={balanceTransferImage}
                    alt="balance-transfer-icon-link"
                    loading="lazy"
                  />
                </a>
              </div>
              <div className="text-column">
                <div className="card-type-text">
                  <h3>
                    <a
                      href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_MONEYTRANSFER"
                      id="money-transfers-title-link"
                    >
                      <strong>Money Transfer</strong>
                      <span className="hide-mobile">-</span> 0% cash into your
                      bank account
                    </a>
                  </h3>
                  <p>
                    Money transfer credit cards let you pay money from the card
                    into your bank account - for a small fee. Use it to clear
                    your overdraft interest-free or give yourself a 0% cash
                    loan.
                  </p>
                </div>
                <div className="card-type-button">
                  <a
                    href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_MONEYTRANSFER"
                    className="card-type-cta"
                    id="money-transfers-cta-link"
                  >
                    Check my chances
                  </a>
                  <p>
                    Full info:
                    <br />
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.moneysavingexpert.com/loans/cut-loan-overdraft-costs"
                      id="money-transfers-full-info-link"
                    >
                      Money Transfer Credit Cards
                    </a>
                  </p>
                </div>
              </div>
            </li>
            <li className="cashback">
              <div className="icon-column">
                <a
                  href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_REWARD_CASHBACK"
                  className="card-type-icon"
                  id="cashback-icon-link"
                >
                  <img
                    width={57}
                    height={57}
                    className="icon-placeholder"
                    aria-hidden
                    src={balanceTransferImage}
                    alt="balance-transfer-icon-link"
                    loading="lazy"
                  />
                </a>
              </div>
              <div className="text-column">
                <div className="card-type-text">
                  <h3>
                    <a
                      href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_REWARD_CASHBACK"
                      id="cashback-title-link"
                    >
                      <strong>Cashback</strong>
                      <span className="hide-mobile">-</span> Pays you when you
                      spend
                    </a>
                  </h3>
                  <p>
                    Cashback cards pay you every time you use them - up to £100s
                    a year in cash or vouchers. Just make you're paying it off
                    in full, otherwise costly interest charges will wipe the
                    gains.
                  </p>
                </div>
                <div className="card-type-button">
                  <a
                    href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_REWARD_CASHBACK"
                    className="card-type-cta"
                    id="cashback-cta-link"
                  >
                    Check my chances
                  </a>
                  <p>
                    Full info:
                    <br />
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.moneysavingexpert.com/credit-cards/cashback-credit-cards"
                      id="cashback-full-info-link"
                    >
                      Cashback Credit Cards
                    </a>
                  </p>
                </div>
              </div>
            </li>
            <li className="rewards">
              <div className="icon-column">
                <a
                  href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_REWARD"
                  className="card-type-icon"
                  id="rewards-icon-link"
                >
                  <img
                    width={57}
                    height={57}
                    className="icon-placeholder"
                    aria-hidden
                    src={balanceTransferImage}
                    alt="balance-transfer-icon-link"
                    loading="lazy"
                  />
                </a>
              </div>
              <div className="text-column">
                <div className="card-type-text">
                  <h3>
                    <a
                      href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_REWARD"
                      id="rewards-title-link"
                    >
                      <strong>Rewards</strong>
                      <span className="hide-mobile">-</span> Get points for
                      spending
                    </a>
                  </h3>
                  <p>
                    These cards allow you to earn rewards points as you spend
                    which you can then convert into money off shopping,
                    discounts on flights, high-street or online vouchers and
                    much more.
                  </p>
                </div>
                <div className="card-type-button">
                  <a
                    href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_REWARD"
                    className="card-type-cta"
                    id="rewards-cta-link"
                  >
                    Check my chances
                  </a>
                  <p>
                    Full info:
                    <br />
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.moneysavingexpert.com/credit-cards/best-credit-card-rewards"
                      id="rewards-full-info-link"
                    >
                      Rewards Credit Cards
                    </a>
                  </p>
                </div>
              </div>
            </li>
            <li className="airlines">
              <div className="icon-column">
                <a
                  href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_REWARD_AIRLINE"
                  className="card-type-icon"
                  id="airlines-icon-link"
                >
                  <img
                    width={57}
                    height={57}
                    className="icon-placeholder"
                    aria-hidden
                    src={balanceTransferImage}
                    alt="balance-transfer-icon-link"
                    loading="lazy"
                  />
                </a>
              </div>
              <div className="text-column">
                <div className="card-type-text">
                  <h3>
                    <a
                      href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_REWARD_AIRLINE"
                      id="airline-title-link"
                    >
                      <strong>Airline</strong>
                      <span className="hide-mobile">-</span> Collect air miles
                      on spending
                    </a>
                  </h3>
                  <p>
                    Airline cards are an extension of frequent flyer schemes;
                    you can earn points for buying your daily coffee or weekly
                    shop on top of those you get for flights. Some also offer
                    'free' flights if you spend enough.
                  </p>
                </div>
                <div className="card-type-button">
                  <a
                    href="https://www.moneysavingexpert.com/eligibility/credit-cards/search/?goal=CC_REWARD_AIRLINE"
                    className="card-type-cta"
                    id="airlines-cta-link"
                  >
                    Check my chances
                  </a>
                  <p>
                    Full info:
                    <br />
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.moneysavingexpert.com/credit-cards/airline-credit-cards"
                      id="airlines-full-info-link"
                    >
                      Airline Credit Cards
                    </a>
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>

      <h2 className="line-heading yellow">
        <span className="large-heading-text subsection">Loans Eligibility</span>
      </h2>
      <div className="row">
        <div className="col-12 col-sm-3 hide-mobile-and-tablet">&nbsp;</div>
        <div className="col-12 col-sm-9 card-types-container">
          <ul className="card-types">
            <li className="loans">
              <div className="icon-column">
                <a
                  href="https://www.moneysavingexpert.com/eligibility/loans-calculator/"
                  className="card-type-icon yellow"
                  id="loans-icon-link"
                >
                  <img
                    width={57}
                    height={57}
                    className="icon-placeholder"
                    aria-hidden
                    src={balanceTransferImage}
                    alt="balance-transfer-icon-link"
                    loading="lazy"
                  />
                </a>
              </div>
              <div className="text-column">
                <div className="card-type-text">
                  <h3>
                    <a
                      href="https://www.moneysavingexpert.com/eligibility/loans-calculator/"
                      id="loans-title-link"
                    >
                      <strong>Loans</strong>
                      <span className="hide-mobile">-</span> Borrow with fixed
                      repayments
                    </a>
                  </h3>
                  <p>
                    If you don't like credit cards, or you want to borrow a
                    large amount, a loan might suit better, though - as ever -
                    only borrow if you're sure you can afford it. The loans
                    eligibility calculator will show your chances.
                  </p>
                </div>
                <div className="card-type-button">
                  <a
                    href="https://www.moneysavingexpert.com/eligibility/loans-calculator/"
                    className="card-type-cta"
                    id="loans-cta-link"
                  >
                    Check my chances
                  </a>
                  <p>
                    Full info:
                    <br />
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.moneysavingexpert.com/eligibility/loans-calculator/"
                      id="loans-full-info-link"
                    >
                      Unsecured Loans
                    </a>
                  </p>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </article>
  )
}

export default CreditCardsArticle
